<template>
  <div class="modal_content">
    <div class="title_label">
      {{ titleLabel }}
    </div>
    <textarea rows="4" cols="40" class="detail_input_field" @input="inputUpdate" maxlength="1000"></textarea>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    inputUpdate(e) {
      this.$emit('inputUpdate', e)
    }
  }
}
</script>
<style scoped>
.detail_input_field {
  height: 190px;
  padding: 10px;
  width: calc(100% - 22px);
}
.title_label {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/modalwindowComponents/textAreaSection.vue